<!-- START Search form-->
<form role="search" [class.open]="visible" (submit)="handleForm()">
    <div class="d-flex align-items-center input_field p-0 overflow-hidden container mx-auto">
        <input [(ngModel)]="term" name="term" class="input_field border-0 border-end m-0 flex-fill rounded-0" type="text" placeholder="Search here..." />
        <span class="bg-transparent border-0 h-100 hw-40 d-flex align-items-center justify-content-center">
        <div class="fa fa-times navbar-form-close cursor" (click)="closeNavSearch()"></div>
    </span>
    </div>
    <button class="d-none" type="submit">Submit</button>
</form>
<!-- END Search form-->
